export default "__VITE_ASSET___OT_2Rhl__"